<div class="container-fluid am-fade-and-slide-bottom center confirm-div">
  <div class="confirm-success-icon">
    <span class="material-icons-outlined cancel-confirm-title">info</span>
  </div>
  <div class="confirm-success-message">
    <app-locale localeKey="ERROR_TITLE" localeView="ERROR_CUSTOMER"></app-locale>
  </div>
  <div class="confirm-success-title">
    <app-locale localeKey="ERROR_MESSAGE" localeView="ERROR_CUSTOMER"></app-locale>
  </div>
  <div class="confirm-number-box" *ngIf="errorRef">
    <div>
      <app-locale localeKey="ERROR_REFNUM" localeView="ERROR_CUSTOMER"></app-locale>
    </div>
    <div>
      <strong [attr.data-automation-id]="'opt-errorcustomer-refnum'">{{errorRef}}</strong>
    </div>
  </div>
  <br>
  <div class="confirm-note1">
    <small>
      <app-locale localeKey="CONTACTUS" localeView="ERROR_CUSTOMER"></app-locale>
    </small>
  </div>
  <div class="text-center confirm-done-btn">
    <button type="submit" class="btn btn-success" (click)="OnNavigateBack()"
      [attr.data-automation-id]="'opt-errorcustomer-done'">
      <app-locale localeKey='DONE_BTN' localeView='IFRAME'></app-locale>
    </button>
  </div>
</div>